<template>
  <div class="rating-chart-list">
    <div v-if="isLoading" class="rating-chart-list__list">
      <div
        v-for="(n, index) in 4"
        :key="index"
        class="ajax__line -round-"
        :style="{ height: '297px', width: '100%', margin: '2px 0' }"
      />
    </div>
    <div v-else class="rating-chart-list__list">
      <ChartWithTable
        title="Заполняемость по прибыли"
        :value="activeRow"
        :values="profitFilled"
        @input="changeRow"
      />
      <ChartWithTable
        title="Заполняемость по прибыли (накопительно)"
        :value="activeRow"
        :values="profitAccumulativeFilled"
        @input="changeRow"
      />
      <ChartWithTable
        title="Заполняемость по выручке"
        :value="activeRow"
        :values="revenueFilled"
        @input="changeRow"
      />
      <ChartWithTable
        title="Заполняемость по выручке (накопительно)"
        :value="activeRow"
        :values="revenueAccumulativeFilled"
        @input="changeRow"
      />
    </div>
  </div>
</template>

<script>
import ChartWithTable from '../../components/ChartWithTable';
import { mapState } from 'vuex';

export default {
  components: {
    ChartWithTable
  },
  data() {
    return {
      activeRow: 0
    };
  },
  computed: {
    ...mapState('ratingSpeedAndHundred', {
      totalCount: s => s.data.totalCount,
      profitFilled: s => s.data.profitFilled,
      profitAccumulativeFilled: s => s.data.profitAccumulativeFilled,
      revenueFilled: s => s.data.revenueFilled,
      revenueAccumulativeFilled: s => s.data.revenueAccumulativeFilled,
      isLoading: s => s.meta.isLoadingAnalytics
    })
  },
  methods: {
    changeRow(value) {
      this.activeRow = value;
    }
  }
};
</script>
